import { ConfirmDialogComponent } from './../shared/confirm-dialog/confirm-dialog.component';
import { TagItem } from './../models/Item';
import { Subscriber } from 'rxjs';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DbmanagerService } from '../services/dbmanager.service';
import { FieldType, TagType } from '../models/Item';
import { MatDialog } from '@angular/material/dialog';
import { ImgDialogComponent } from '../shared/img-dialog/img-dialog.component';
import { ElementRef } from '@angular/core';
import { NgxBarcodeComponent } from 'ngx-barcode';


@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.css']
})
export class TagComponent implements OnInit, OnDestroy {
  barcodeIsValid = true;
  fieldType = FieldType;
  tagType = TagType;
  tag = TagType.None;
  locations: Array<string>;
  selectedLocation: string;
  leftQRTags = 5;

  FieldsTitles: Array<string>;
  BarCodes: Array<string>;
  FieldsValues: Array<any>;
  EnteredBarCode = '0000000000000';
  selectedBarType = 'EAN13';
  UID = 'QR:00:00:00:00:00:00';
  subscriber;
  constructor(private dbService: DbmanagerService, private dialog: MatDialog) { }

  @ViewChild('someVar') el;

  ngOnInit(): void {
    this.locations = new  Array<string>();
    this.dbService.locations.forEach(loc => {
      this.locations.push(loc.NAME);
    });
    this.BarCodes = new Array<string>(11);
    this.FieldsValues = new Array<any>(13);
    this.FieldsTitles = new Array<string>(13);
    this.FieldsValues[FieldType.Category] = '';
    this.FieldsValues[FieldType.Description] = '';
    this.FieldsValues[FieldType.Title] = '';
    this.FieldsValues[FieldType.Mark] = '';
    this.FieldsValues[FieldType.Size] = '';
    this.FieldsValues[FieldType.Link] = '';
    this.FieldsValues[FieldType.PurchaseDate] = new Date();
    this.FieldsValues[FieldType.Location] = '';
    this.FieldsValues[FieldType.Remarks] = '';
    this.FieldsValues[FieldType.State] = '';
    this.FieldsValues[FieldType.EvidNumber] = '';

    this.FieldsTitles[FieldType.RFIDNumber] = $localize`:@@itemdetails.rfidNumber:Numer RFID`;
    this.FieldsTitles[FieldType.EvidNumber] = $localize`:@@itemdetails.inventoryNr:Numer Inwentaryzacyjny`;
    this.FieldsTitles[FieldType.Category] = $localize`:@@itemdetails.category:Numer Kategoria`;
    this.FieldsTitles[FieldType.Mark] = $localize`:@@itemdetails.mark:Marka`;
    this.FieldsTitles[FieldType.PurchaseDate] = $localize`:@@itemdetails.purchasedate:Data Zakupu`;
    this.FieldsTitles[FieldType.Size] =  $localize`:@@itemdetails.size:Rozmiar`;
    this.FieldsTitles[FieldType.Link] = $localize`:@@itemdetails.link:Link`;
    this.FieldsTitles[FieldType.State] = $localize`:@@itemdetails.state:Ilość/Stan`;
    this.FieldsTitles[FieldType.Location] = $localize`:@@itemdetails.location:Lokalizacja`;
    this.FieldsTitles[FieldType.Remarks] = $localize`:@@itemdetails.remarks:Uwagi`;
    this.FieldsTitles[FieldType.Description] = $localize`:@@itemdetails.desc:Opis`;
    this.FieldsTitles[FieldType.Title] = $localize`:@@itemdetails.title:Tytuł`;
    this.FieldsTitles[FieldType.LinkedFileds] = $localize`:@@itemdetails.linkedproducts:Produkty powiązane`;

    this.BarCodes[0] = 'CODE128';
    this.BarCodes[1] = 'CODE128A';
    this.BarCodes[2] = 'CODE128B';
    this.BarCodes[3] = 'CODE128C';
    this.BarCodes[4] = 'CODE39';
    this.BarCodes[5] = 'EAN2';
    this.BarCodes[6] = 'EAN5';
    this.BarCodes[7] = 'EAN8';
    this.BarCodes[8] = 'ITF14';
    this.BarCodes[9] = 'MSI';
    this.BarCodes[10] = 'EAN13';

    this.leftQRTags = this.dbService.getLeftTags().QRTagsLeft;
    this.subscriber = this.dbService.getCompanyItems().subscribe(data => {
      this.leftQRTags = data.QRTagsLeft;
    });
  }

  ngOnDestroy(): void {
    this.subscriber.unsubscribe();
  }

  invalidBarCode() {
    return((this.el as NgxBarcodeComponent).bcElement.nativeElement.innerText.length === 0) ;
  }

  saveTag() {
    let type;
    if (this.tag === TagType.QR) {
      type = 'QR';
    } else {
      type = this.selectedBarType;
      this.UID = this.EnteredBarCode;
      if (this.invalidBarCode()) {
        this.dialog.open(ConfirmDialogComponent, {disableClose: true,
          data: {content: $localize`:@@tag.tagWrong:Nieprawidłowy format kodu kreskowego`}}) ;

        return ;
      }
    }

    const tag = {
      CATEGORY: this.FieldsValues[FieldType.Category],
      DESCRIPTION: this.FieldsValues[FieldType.Description],
      EDIT_DATETIME: new Date(),
      MARK: this.FieldsValues[FieldType.Mark],
      REG_NUM: this.FieldsValues[FieldType.EvidNumber],
      SIZE: this.FieldsValues[FieldType.Size],
      TITLE: this.FieldsValues[FieldType.Title],
      TAG_UID: this.UID,
      PURCHASE_DATE: this.FieldsValues[FieldType.PurchaseDate],
      TYPE: type,
      USER_ID: this.dbService.currentUserID,
    };

    const event = {
      LOCATION: this.FieldsValues[FieldType.Location],
      REMARKS: this.FieldsValues[FieldType.Remarks],
      EVENT_DATETIME: new Date(),
      STATE: this.FieldsValues[FieldType.State],
      TAG_UID: this.UID,
      USER_ID: this.dbService.currentUserID,
      PHOTOS: { 0 : '',
                1 : '',
                2 : ''}
    };

    const subscribver = this.dbService.getTagExistResult().subscribe(result => {
      if (result) {
        this.dialog.open(ConfirmDialogComponent, {disableClose: true,
          data: {content: $localize`:@@tag.barCodeExisting:Kod kreskowy o takim identyfikatore istnieje już w bazie danych`}}) ;
      } else {
        this.dbService.createNewTag(this.UID, tag, event);
        this.FieldsValues[FieldType.Category] = '';
        this.FieldsValues[FieldType.Description] = '';
        this.FieldsValues[FieldType.Title] = '';
        this.FieldsValues[FieldType.Mark] = '';
        this.FieldsValues[FieldType.Size] = '';
        this.FieldsValues[FieldType.Link] = '';
        this.FieldsValues[FieldType.PurchaseDate] = new Date();
        this.FieldsValues[FieldType.Location] = '';
        this.FieldsValues[FieldType.Remarks] = '';
        this.FieldsValues[FieldType.State] = '';
        this.FieldsValues[FieldType.EvidNumber] = '';
        this.dialog.open(ConfirmDialogComponent, {disableClose: true,
                                                  data: {content: $localize`:@@tag.tagAdded:Znacznik został dodany do bazy`}}) ;
      }
      subscribver.unsubscribe();
    });
    this.dbService.checkTagExisting(this.UID);
  }

  chooseTag(type: TagType) {
    this.tag = type ;
    switch (type) {
      case TagType.QR:
        this.UID = ('QR' + '0' + new Date().valueOf().toString(16).toUpperCase()).match(/.{1,2}/g).join(':');
        break;
      case TagType.QR:
        break;
      case TagType.UHF:
        break;
      case TagType.BAR:
        this.UID =  this.EnteredBarCode;
        break;
      case TagType.None:
        break;
    }
  }
}
